import { render, staticRenderFns } from "./ContactThankYouPage.vue?vue&type=template&id=9993a90a&scoped=true"
import script from "./ContactThankYouPage.vue?vue&type=script&lang=js"
export * from "./ContactThankYouPage.vue?vue&type=script&lang=js"
import style0 from "./ContactThankYouPage.vue?vue&type=style&index=0&id=9993a90a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9993a90a",
  null
  
)

export default component.exports